import {
  Button,
  CloseButton,
  Divider,
  Flex,
  Heading,
  useToast,
} from "@chakra-ui/react";
import Modal from "../overlay/Modal";
import Overlay from "../overlay/OverLay";
import InputComponent from "../UI/Input";
import { useState } from "react";
import { createDesignation } from "../../util/http";

export default function CreateDesignation({ show }) {
  const [loading, setLoading] = useState(false);
  const [designation, setDesignation] = useState("");
  const [description, setDescription] = useState("");
  const toast = useToast();

  function closeMenu() {
    show(false);
  }

  async function createHandler() {
    const data = { designation, description };

    if (!designation || !description) {
      toast({
        title: `Invalid entries`,
        description: ``,
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
      return;
    }

    try {
      setLoading(true);
      await createDesignation(data);
      closeMenu();
      window.location.reload()
      toast({
        title: `New Designation Created`,
        description: ``,
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast({
        title: `Error`,
        description: `${
          error?.response?.data.message || "something went wrong"
        }`,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  }

  return (
    <>
      <Overlay hide={closeMenu} />
      <Modal hide={closeMenu}>
        <Flex w="100%" align="start" direction="column" gap="1rem" py="1rem">
          <Flex w="100%" align="center" justify="space-between">
            <Heading size="md" color="#333" fontWeight={600}>
              Create Designation
            </Heading>
            <CloseButton colorScheme="red" onClick={closeMenu} />
          </Flex>
          <Divider />
          <InputComponent
            onChange={(e) => setDesignation(e.target.value)}
            value={designation}
            label="Enter Designation Name"
            placeholder="Enter Designation Name"
          />
          <InputComponent
            onChange={(e) => setDescription(e.target.value)}
            value={description}
            label="Enter Designation Description"
            placeholder="Enter Designation Description"
          />
          <Button
            variant="solid"
            bg="brand.900"
            color="white"
            isLoading={loading}
            loadingText=""
            onClick={createHandler}
          >
            Submit
          </Button>
        </Flex>
      </Modal>
    </>
  );
}
